import {useHasPlan, useIsLoggedIn} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {type FC} from "react";
import {Navigate, Outlet, useSearchParams} from "react-router";

const RequirePlan: FC = () => {
  const userId = useUserStore(state => state.user.id);
  const isLoggedIn = useIsLoggedIn();
  const hasPlan = useHasPlan();
  const [searchParams] = useSearchParams();

  if (!userId) return null;
  if ((!hasPlan || !isLoggedIn) && searchParams.get("isUgc") === "false") {
    return <Navigate to={!isLoggedIn ? "/login/" : "/plans/"} replace />;
  }
  return <Outlet />;
};

export default RequirePlan;
